import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '~/components/Text';
import LoadImage from '../../assets/img/animate/loading.svg';
import { Container, LoadingImage } from './styles';

export function LoaderLista(props) {
	const { children, loading, lista, error, message } = props;

	if (error === null) {
		if (loading === false) {
			if (lista?.length > 0) {
				// eslint-disable-next-line react/jsx-no-useless-fragment
				return <>{children && children}</>;
			}
			return (
				<Container>Não há informações no período selecionado</Container>
			);
		}
		return (
			<Container>
				<LoadingImage src={LoadImage} alt="Carregando" width="100" />
				{message ? <div>{message}</div> : <div>Carregando...</div>}
			</Container>
		);
	}
	return (
		<Container>
			Não foi possível carregar as informações
			<br />
			<Text color="red" weight="bold">
				{`Erro: ${error}`}
			</Text>
		</Container>
	);
}

export function LoaderObjeto(props) {
	const { children, loading, obj, error } = props;
	if (error === null) {
		if (loading === false && obj !== undefined) {
			if (Object.keys(obj).length > 0) {
				// eslint-disable-next-line react/jsx-no-useless-fragment
				return <>{children && children}</>;
			}
			return (
				<Container>
					Não há informações no período selecionado
					<br />
					<Text color="red" weight="bold">
						{`Erro: ${error}`}
					</Text>
				</Container>
			);
		}
		return (
			<Container>
				<LoadingImage src={LoadImage} alt="Carregando" width="100" />
				<div>Carregando...</div>
			</Container>
		);
	}
	return (
		<Container>
			Não foi possível carregar as informações
			<br />
			<Text color="red" weight="bold">
				{`Erro: ${error}`}
			</Text>
		</Container>
	);
}

export function LoaderMini(props) {
	const { width } = props;
	return <LoadingImage src={LoadImage} alt="Carregando" width={width} />;
}

LoaderLista.propTypes = {
	lista: PropTypes.arrayOf(Object).isRequired,
	loading: PropTypes.bool.isRequired,
	children: PropTypes.node,
	error: PropTypes.oneOfType([PropTypes.any]),
};

LoaderLista.defaultProps = {
	error: null,
	children: null,
};

LoaderMini.propTypes = {
	width: PropTypes.string,
};

LoaderMini.defaultProps = {
	width: '',
};
